import React from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { ErrorBoundary } from 'components'
import useGet, { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import { useForm, FormProvider } from 'react-hook-form'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { IGetAllItemsResponse, IGetAllSubItensParams, IGetAllSubItensResponse } from 'services/GST/CadastroItensSubitensSeguranca'
import * as yup from 'yup'

import Form from './components/Form'
import TableItems from './components/TableItems'
import { IFormSecurityItem } from './types'

interface ISecurityItemProps {
  data: IPaginatedEntityGST<IGetAllItemsResponse[]>
  refresh: (_params: { pageNumber: number }) => void
  page: number
  rowsPerPage: number
  handleChangePage: IHandleChangePage
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
}

const SCHEMA = yup.object({
  txDescricaoItem: yup.string(),
  txItem: yup.string(),
  txLegislacao: yup.string()
})

const SecurityItem: React.FC<ISecurityItemProps> = ({
  data,
  refresh,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage
}) => {

  const methods = useForm<IFormSecurityItem>({
    resolver: yupResolver(SCHEMA)
  })

  return (
    <FormProvider {...methods}>
      <Form refresh={refresh} />
      <ErrorBoundary>
        <TableItems
          data={data}
          refresh={refresh}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </ErrorBoundary>
    </FormProvider>
  )
}

export default SecurityItem
